import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import RegionTabsLoading from "../RegionTabsLoading";
import Roles from "../../../../common/enums/Roles";
import { UserDetails } from "../../../../domain/models/uset-details";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import { TerritoryDataStore } from "../../../../store/main/TerritoryDataStore";
import ZoneTabsLoading from "../ZoneTabsLoading";
import { BrickWorkingReportsStore } from "../../../../store/main/BrickWorkingReportsStore";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;

}

type Props = {
  userDetails: UserDetails;
    year: number;
      onHierarchyChange: (zone?: string, region?: string) => void;
};

const BrickWorkingReportTab: React.FC<Props> = ({
  userDetails = {} as UserDetails,
  year,
  onHierarchyChange,
}) => {
  const {
    zoneMasterData,
    regionMasterData,
    fetchZoneMaster,
    fetchRegionMaster,
  } = TerritoryDataStore();

const {FetchBrickWorkingReport , fetchBrickWorkingReportResponse} = BrickWorkingReportsStore();
  const { userRole } = CustomerDatabaseStore();

const [zoneId, setZoneId] = React.useState<number | null>(null);
const [zoneName, setZoneName] = React.useState<string>("");

const [regionId, setRegionId] = React.useState<number | null>(null);
const [regionName, setRegionName] = React.useState<string>("");

React.useEffect(() => {
  fetchZoneMaster();
}, []);



const handleZoneChange = (_: React.SyntheticEvent, newValue: number) => {
  const selectedZone = zoneMasterData.find(z => z.id === newValue);
  if (!selectedZone) return;
  setZoneId(selectedZone.id);
  setZoneName(selectedZone.name);
  setRegionId(null);
  setRegionName("");
  fetchRegionMaster([selectedZone.id]);
};

const handleRegionChange = (event: SelectChangeEvent<number>) => {
  const id = Number(event.target.value);
  const selectedRegion = regionMasterData.find(r => r.id === id);
  if (!selectedRegion) return;

  setRegionId(selectedRegion.id);
  setRegionName(selectedRegion.name);

  onHierarchyChange(zoneName, selectedRegion.name);
};


React.useEffect(() => {
  if (!zoneMasterData.length) return;

  let defaultZone;

  if (userRole.role === Roles.COUTNRY_MANAGER) {
    defaultZone = zoneMasterData[0];
  } else {
    defaultZone = zoneMasterData.find(
      z => z.id === userDetails.hq_zone_id
    );
  }

  if (!defaultZone) return;

  setZoneId(defaultZone.id);
  setZoneName(defaultZone.name);

  fetchRegionMaster([defaultZone.id]);
}, [zoneMasterData]);



React.useEffect(() => {
  if (!regionMasterData.length || !zoneName) return;

  const defaultRegion =
    regionMasterData.find(r => r.id === userDetails.hq_region_id) ??
    regionMasterData[0];

  setRegionId(defaultRegion.id);
  setRegionName(defaultRegion.name);

  // 🚀 SINGLE source of truth
  onHierarchyChange(zoneName, defaultRegion.name);
}, [regionMasterData]);

  const handleSelectRegionBasedonZone = (id: number) => {
    fetchRegionMaster([id]);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box paddingX={2}>
        {zoneMasterData.length > 0 ? (
          <Tabs
            value={zoneId}
            onChange={handleZoneChange}
            aria-label="basic tabs example"
          >
            {zoneMasterData &&
              zoneMasterData.map((zone) => {
                return (
                  <Tab
                    key={zone.id}
                    label={zone.name}
                    value={zone.id}
                    onClick={() => {
                      handleSelectRegionBasedonZone(zone.id);
                    }}
                  />
                );
              })}
          </Tabs>
        ) : (
          <ZoneTabsLoading />
        )}
      </Box>
      {regionMasterData.length > 0 ? (
        <FormControl sx={{ width: "20%", marginTop: 2 }} size="small">
          <InputLabel>Select Region</InputLabel>
          <Select
            value={regionId ?? ""}
            size="small"
            label="Select Region"
            onChange={(e) => handleRegionChange(e)}
          >
            {regionMasterData.map((data) => (
              <MenuItem key={data.id} value={data.id}>
                {data.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <RegionTabsLoading />
      )}
    </Box>
  );
};
export default BrickWorkingReportTab;
